import React, { useEffect, useState } from 'react';

import { FlexBox, Text } from '@blockworks/ui/components';
import { CheckIcon, XCloseIcon } from '@blockworks/ui/icon';

import * as commonSchema from '@/components/auth/forms/common.schema';

interface PasswordRequirementsProps {
    password: string;
}

type PasswordSchema = typeof commonSchema.password;

const Requirement = ({ test, value }: { test: PasswordSchema['tests'][number]; value: string }) => {
    const [valid, setValid] = useState(false);

    useEffect(() => {
        test(
            { value, options: {}, originalValue: undefined, schema: commonSchema.password },
            () => setValid(false),
            () => setValid(true),
        );
    }, [value, test]);

    const icon = valid ? <CheckIcon className="w-3.5 text-content-success" /> : <XCloseIcon className="w-3.5" />;
    return (
        <FlexBox gap="xs" alignItems="center">
            {icon}
            <Text size="xxs" color={valid ? 'success' : 'base'}>
                {` ${test.OPTIONS?.message}`}
            </Text>
        </FlexBox>
    );
};

export const PasswordRequirements = ({ password }: PasswordRequirementsProps) => {
    const requirements = commonSchema.password.resolve({ value: password });

    return (
        <FlexBox col gap="sm">
            <Text size="xs" color="muted">
                Requirements:
            </Text>
            {requirements.tests.map(test => {
                return <Requirement key={`${test.OPTIONS?.message}`} test={test} value={password} />;
            })}
        </FlexBox>
    );
};
